<template>
   <!--采购商指数-->
   <div id='buyerData' class='provide_container'></div>
</template>
<script>
import { http } from '@/http'
import echarts from 'echarts'
import 'echarts/chart/pie'
import { option as buyerlineOption } from '@/zjljChartsConfig/buyerDataOption.js' // 配置项
// import {option as dataResponse} from '@/zjljChartsConfig/provideData.js' //临时数据
import { filterArr } from '@/utils/dataFilter.js' // 数组空值转换

export default{

  data () {
    return {
      xAxisData: [],
      dataStore: [],
      showCount: 12, // 显示的数据数量
      showIndexPre: 0,
      showIndexLast: 10
    }
  },
  methods: {
    // 获取地图数据
    getData (cb) {
      http.get('/canmou/tianji/product/purchaser_index?product_id=8048&county_id=2215').then(res => {
        this.dataResponse = res.data
        // 线数据
        this.currentDataStore = filterArr(this.dataResponse.data.current_year_index)
        this.lastDataStore = filterArr(this.dataResponse.data.last_year_index)
        // x轴数据
        this.xAxisDataStore = this.dataResponse.data.date.map(item => {
          return `${item.substring(0, 2)} / ${item.substring(2, 4)}`
        })

        // 数据总数
        this.countAll = this.dataResponse.data.date.length
        if (this.dataResponse.status === 0) {
          cb && cb()
        }
      })
    },
    // 初始化数据
    initOption (data) {
      // this.data=this.dataStore.slice(0,this.showCount);
      // this.xAxisData=this.xAxisDataStore.slice(0,this.showCount);

      let len = this.xAxisDataStore.length
      this.dataCurrent = this.currentDataStore.slice(0, len)
      this.dataLast = this.lastDataStore.slice(0, len)
      this.xAxisData = this.xAxisDataStore.slice(0, len)
      // x轴数据
      buyerlineOption.xAxis[0].data = this.xAxisData
      // x轴间隔
      buyerlineOption.xAxis[0].axisLabel.interval = Math.floor(len / this.showCount) - 1

      // 线数据
      buyerlineOption.series = [{
        name: '今年采购商指数',
        type: 'line',
        data: this.dataCurrent,
        smooth: true,
        itemStyle: {
          normal: {
            color: '#28c305', // 折线点的颜色
            lineStyle: {
              color: '#28c305'// 折线的颜色
            }
          }
        }

        //  //线上显示圆点
        //  showAllSymbol: true,
        //  symbol: 'circle',
        //  symbolSize: 6,

        //  //线上方显示文字

        // itemStyle: {
        //    normal: {
        //       label: {
        //          show: true,
        //          formatter: "{b}: {c}",
        //          textStyle: {
        //             color: '#fff',
        //             fontSize:20
        //          }
        //       },
        //        textColor : '#000'
        //     },
        //     emphasis: {
        //       label: {
        //          show: true
        //        }
        //     }
        // }

        /// ///

      }, {
        name: '去年采购商指数',
        type: 'line',
        data: this.dataLast,
        smooth: true,
        itemStyle: {
          normal: {
            color: '#fe971a', // 折线点的颜色
            lineStyle: {
              color: '#fe971a'// 折线的颜色
            }
          }
        }
      }
      ]

      // this.lineChart.setOption(buyerlineOption)
    }
  },
  mounted () {
    this.lineChart = echarts.init(document.getElementById('buyerData'))
    // 改变数据设置动效
    var that = this
    let changeLinePoint = () => {
      if (that.showIndexLast >= that.countAll) {
        that.showIndexPre = -1
        that.showIndexLast = that.showCount - 1
      }
      // that.showIndexPre++;
      // that.showIndexLast++;
      that.showIndexPre = 0
      that.showIndexLast = that.xAxisDataStore.length
      that.dataCurrent.length = 0
      that.dataCurrent.push(...that.currentDataStore.slice(that.showIndexPre, that.showIndexLast))
      that.xAxisData.length = 0
      that.xAxisData.push(...that.xAxisDataStore.slice(that.showIndexPre, that.showIndexLast))
      that.lineChart.setOption(buyerlineOption)
      setTimeout(() => {
        // changeLinePoint();
      }, 2000)
    }
    init()
    function init () {
      // 获取数据
      that.getData(() => {
        // 处理返回数据
        that.initOption(that.dataResponse)
        // 设置数据切换
        changeLinePoint()
      })
    }

    // 每天更新一次数据
    setInterval(function () {
      init()
    }, 24 * 60 * 60 * 1000)
  }
}

</script>
<style lang='less'>

  .provide_container{
    width: 100%;
    height:100%;
    background:none;
  }
</style>
